'use client';

import { useEffect, useState } from 'react';
import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { useShareButtonTracking } from '../Tracking/hooks/useShareButtonTracking/useShareButtonTracking';

export type ShareButtonProps = {
  sharedTitle: string;
};

/**
 * Displays a 'share' button wrapped by a grid on browsers that support native web-share-api
 * */

export const ShareButton = ({ sharedTitle }: ShareButtonProps) => {
  const [canShare, setCanShare] = useState<boolean | null>(null);

  const { trackButtonClick, trackViewButton } = useShareButtonTracking();

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.navigator.share !== 'undefined') {
      setCanShare(true);
    } else {
      setCanShare(false);
    }
  }, [setCanShare]);

  useEffect(() => {
    if (canShare === true) {
      trackViewButton();
    }
  }, [canShare, trackViewButton]);

  if (canShare === null) {
    return <Skeleton className="size-5 rounded-full" />;
  }

  if (!canShare) return null;

  const onClick = async () => {
    trackButtonClick();
    await window.navigator.share({
      title: sharedTitle,
      text: sharedTitle,
      url: window.location.href,
    });
  };

  return (
    <Button
      onClick={onClick}
      className="bg-color-text-light h-5 w-5 touch-manipulation rounded-full border-none p-0 shadow-md"
    >
      <span aria-disabled="true" className="icon-emp-android size-2" />
    </Button>
  );
};
